// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M4 2H20V6H4V2Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M6 17H18V22H6V17Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M0.5 8H23.5V19H20V15H4V19H0.5V8ZM20 10.5H18V12.5H20V10.5Z"}}]};

const PrintFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'print-filled',
    ref,
    icon: element,
  },
));

PrintFilledIcon.displayName = 'PrintFilledIcon';

export default PrintFilledIcon;
